import styled from "styled-components";

const VideoContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 25px;
  height: 0;
  margin: 0 auto;

  & iframe {
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

interface Props {
  link: string;
}

const YoutubeEmbed = ({ link }: Props): JSX.Element | null => {
  const videoRegex = /youtube\.com\/watch\?v=([a-zA-Z0-9_-]*)&?.*/;

  return (
    <VideoContainer>
      <iframe
        width="420"
        height="315"
        src={`https://www.youtube.com/embed/${
          videoRegex.exec(link)![1]
        }?rel=0&enablejsapi=1`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </VideoContainer>
  );
};

export default YoutubeEmbed;
